const DEV_PASSWORD_KEY = 'dev-password-hash';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

/** Parent domain shared by all department subdomains, or undefined for a host-only cookie. */
export function getDevPasswordCookieDomain(
  hostname: string,
): string | undefined {
  const isIp = /^[\d.]+$/.test(hostname) || hostname.includes(':');
  const labels = hostname.split('.');
  if (isIp || hostname === 'localhost' || labels.length < 3) return undefined;
  return labels.slice(1).join('.');
}

function writeCookie(value: string, maxAge: number): void {
  const domain = getDevPasswordCookieDomain(location.hostname);
  document.cookie = [
    `${DEV_PASSWORD_KEY}=${value}`,
    'path=/',
    `max-age=${maxAge}`,
    'SameSite=Lax',
    domain && `domain=${domain}`,
    location.protocol === 'https:' && 'Secure',
  ]
    .filter(Boolean)
    .join('; ');
}

export function storeDevPasswordHash(hash: string): void {
  writeCookie(hash, ONE_YEAR_SECONDS);
}

export function clearDevPasswordHash(): void {
  writeCookie('', 0);
  sessionStorage.removeItem(DEV_PASSWORD_KEY);
}

/** Reads the hash from the cookie, moving a hash left in sessionStorage over to it. */
export function readDevPasswordHash(): string | null {
  const match = document.cookie.match(
    /(?:^|;\s*)dev-password-hash=([a-f0-9]+)/,
  );
  if (match) return match[1];

  const legacy = sessionStorage.getItem(DEV_PASSWORD_KEY);
  if (!legacy) return null;
  storeDevPasswordHash(legacy);
  sessionStorage.removeItem(DEV_PASSWORD_KEY);
  return legacy;
}
